<template>
  <div>
    <v-dialog v-model="show" persistent max-width="50%">
      <v-card>
        <v-app-bar text color="secondary">
          <v-toolbar-title class="subheading">{{ $t("enrolments.verify_title") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <span>
            <v-chip color="warning darken-2" dark label> {{ $t("global.match_grade") }}: {{ matchGrade }}% </v-chip>
          </span>
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="px-3">
          <v-simple-table dense class="merge-table mt-3">
            <thead>
              <tr>
                <th class="grey-td text-sm-left" width="25%">{{ $t("enrolments.merge_th_field") }}</th>
                <th class="grey-td text-sm-left" width="25%">
                  {{ $t("enrolments.merge_th_enrolment") }}
                  <action-button
                    type="edit"
                    :icon_only="true"
                    @click="showForm(enrolment.id, 'enrolment-basic', null, null)"
                    v-if="$can('enrolment-edit')"
                    small
                  />
                </th>
                <th class="grey-td text-sm-left" width="25%">{{ $t("enrolments.merge_th_participant") }}</th>
                <th class="green-td text-sm-left" width="25%">{{ $t("enrolments.merge_th_result") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td :class="d_first_names.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_first_name") }}</td>
                <td :class="d_first_names.length > 1 ? 'existin-td' : ''">{{ this.enrolment.first_name }}</td>
                <td :class="d_first_names.length > 1 ? 'existin-td' : ''">{{ this.participant.first_name }}</td>
                <td :class="d_first_names.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_first_names" v-model="output.first_name" text small dense></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_last_names.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_last_name") }}</td>
                <td :class="d_last_names.length > 1 ? 'existin-td' : ''">{{ this.enrolment.last_name }}</td>
                <td :class="d_last_names.length > 1 ? 'existin-td' : ''">{{ this.participant.last_name }}</td>
                <td :class="d_last_names.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_last_names" v-model="output.last_name" text small dense></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_emails.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_email") }}</td>
                <td :class="d_emails.length > 1 ? 'existin-td' : ''">{{ this.enrolment.email }}</td>
                <td :class="d_emails.length > 1 ? 'existin-td' : ''">{{ this.participant.email }}</td>
                <td :class="d_emails.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_emails" v-model="output.email" text small dense></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_mobiles.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_mobile") }}</td>
                <td :class="d_mobiles.length > 1 ? 'existin-td' : ''">{{ this.enrolment.mobile }}</td>
                <td :class="d_mobiles.length > 1 ? 'existin-td' : ''">{{ this.participant.mobile }}</td>
                <td :class="d_mobiles.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_mobiles" v-model="output.mobile" text small dense></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_date_of_births.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_date_of_birth") }}</td>
                <td :class="d_date_of_births.length > 1 ? 'existin-td' : ''">{{ this.enrolment.date_of_birth }}</td>
                <td :class="d_date_of_births.length > 1 ? 'existin-td' : ''">{{ this.participant.date_of_birth }}</td>
                <td :class="d_date_of_births.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select
                    class="caption merge-dropdown"
                    :items="d_date_of_births"
                    v-model="output.date_of_birth"
                    text
                    small
                    dense
                  ></v-select>
                </td>
              </tr>

              <tr>
                <td :class="d_streets.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_address_street") }}</td>
                <td :class="d_streets.length > 1 ? 'existin-td' : ''">{{ this.enrolment.street }}</td>
                <td :class="d_streets.length > 1 ? 'existin-td' : ''">{{ this.participant.street }}</td>
                <td :class="d_streets.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_streets" v-model="output.street" text small dense></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_cities.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_address_city") }}</td>
                <td :class="d_cities.length > 1 ? 'existin-td' : ''">{{ this.enrolment.city }}</td>
                <td :class="d_cities.length > 1 ? 'existin-td' : ''">{{ this.participant.city }}</td>
                <td :class="d_cities.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_cities" v-model="output.city" text small dense></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_zips.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_address_zip") }}</td>
                <td :class="d_zips.length > 1 ? 'existin-td' : ''">{{ this.enrolment.zip }}</td>
                <td :class="d_zips.length > 1 ? 'existin-td' : ''">{{ this.participant.zip }}</td>
                <td :class="d_zips.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_zips" v-model="output.zip" text small dense></v-select>
                </td>
              </tr>
              <!--<tr>
                <td :class="d_companies.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_company") }}</td>
                <td :class="d_companies.length > 1 ? 'existin-td' : ''">{{ this.enrolment.organisation ? this.enrolment.organisation.name : "" }}</td>
                <td :class="d_companies.length > 1 ? 'existin-td' : ''">{{ this.participant.company ? this.participant.company.name : "" }}</td>
                <td :class="d_companies.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select
                    class="caption merge-dropdown"
                    :items="d_companies"
                    item-text="text"
                    item-value="key"
                    v-model="output.company"
                    text
                    small
                    dense
                  ></v-select>
                </td>
              </tr>-->
              <!--<tr>
                                <td class="grey-td">{{ this.$t('enrolments.p_image') }}</td>
                                <td class="text-center">
                                    <v-avatar color="indigo" class="d-content">
                                        <v-img 
                                            :src="this.enrolment.image_url ? this.enrolment.image_url : require('@/assets/img/no-image.jpg')">
                                        </v-img>
                                    </v-avatar>
                                </td>
                                <td class="text-center">
                                    <v-avatar color="indigo" class="d-content">
                                        <v-img 
                                            :src="this.participant.image_url ? this.participant.image_url : require('@/assets/img/no-image.jpg')">
                                        </v-img>
                                    </v-avatar>
                                </td>
                                <td class="green-td">
                                    <v-select
                                        class="caption merge-dropdown"
                                        :items="d_images"
                                        item-text="text"
                                        item-value="key"
                                        v-model="output.image"
                                        text
                                        small
                                        dense
                                    ></v-select>
                                </td>
                            </tr>-->
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions class="pr-2 pt-2 pb-3">
          <v-spacer></v-spacer>

          <action-button type="merge" :text="$t('enrolments.force_accept')" @click="createasnew()" :disabled="Boolean(existIn)" small />

          <action-button type="merge" @click="merge()" v-if="$can('participant-access')" color="success" small />
          <action-button type="cancel" color="error" @click="cancel" small />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogForm" persistent max-width="75%">
      <div class="form-modal pa-4">
        <component
          :is="currentLoadedForm.form"
          :id="currentLoadedForm.id"
          :modal="true"
          @return_modal_form="return_modal_form"
          @return_modal_cancel_form="return_modal_cancel_form"
        ></component>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "EnrolmentVerifyPopup",
  props: {
    id: {
      type: Number,
      required: true
    },
    validate: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    "enrolment-basic-form": () => import("../../enrolments/components/FormBasic")
  },

  data() {
    return {
      show: false,
      data: [],
      enrolment: {},
      participant: {},
      output: {},
      matchGrade: 0,
      d_first_names: [],
      d_last_names: [],
      d_emails: [],
      d_mobiles: [],
      d_date_of_births: [],
      d_streets: [],
      d_cities: [],
      d_states: [],
      d_zips: [],
      d_images: [],
      d_countries: [],
      d_companies: [],

      currentFormId: "",
      currentForm: "",
      showDialogForm: false,

      existIn: null
    }
  },

  created() {
    if (this.id) {
      this.verify(this.id)
    }
  },

  computed: {
    currentLoadedForm: function () {
      let form,
        id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
      }

      return {
        id: id,
        form: form
      }
    }
  },

  methods: {
    verify(id, enrupdate = false) {
      if (id > 0) {
        axios.post(this.API_URL + "participant/verify/" + id).then((res) => {
          if (this.validate) {
            this.$emit("callback_enrverify_validate", { status: res.data.status })
          } else {
            if (res.data.status == "exist") {
              this.show = true
              this.existIn = res.data.exist_in
              this.data = res.data.data
              this.premerge()
            } else {
              if (enrupdate) {
                this.premerge()
                this.existIn = null
              } else {
                this.$emit("callback_enrverify_postprocess")
                this.show = false
              }
            }
          }
        })
      }
    },

    premerge() {
      axios
        .get(this.API_URL + "enrolment/" + this.id)
        .then((res) => {
          this.enrolment = JSON.parse(JSON.stringify(res.data.data))
          this.participant = this.data

          if (this.enrolment && this.participant) {
            this.d_first_names = _.union(_.compact([this.participant.first_name, this.enrolment.first_name]))
            this.d_last_names = _.union(_.compact([this.participant.last_name, this.enrolment.last_name]))
            this.d_emails = _.union(_.compact([this.participant.email, this.enrolment.email]))
            this.d_mobiles = _.union(_.compact([this.participant.mobile, this.enrolment.mobile]))
            this.d_date_of_births = _.union(_.compact([this.participant.date_of_birth, this.enrolment.date_of_birth]))
            this.d_streets = _.union(_.compact([this.participant.street, this.enrolment.street]))
            this.d_cities = _.union(_.compact([this.participant.city, this.enrolment.city]))
            //this.d_states = _.union(_.compact([this.participant.state, this.enrolment.state]))
            this.d_zips = _.union(_.compact([this.participant.zip, this.enrolment.zip]))
            //this.d_countries = _.union(_.compact([this.participant.country, this.enrolment.country]))

            this.matchGrade = this.$getMatchGrade(
              _.compact([this.participant.first_name, this.enrolment.first_name]),
              _.compact([this.participant.last_name, this.enrolment.last_name]),
              _.compact([this.participant.email, this.enrolment.email]),
              _.compact([this.participant.mobile, this.enrolment.mobile]),
              _.compact([this.participant.date_of_birth, this.enrolment.date_of_birth])
            )

            if (this.participant.company_id)
              this.d_companies.push({ key: this.participant.company_id, text: this.participant.company.name })
            if (this.enrolment.enrolment_organisation_id)
              this.d_companies.push({ key: this.enrolment.enrolment_organisation_id, text: this.enrolment.organisation.name })

            if (this.participant.image) this.d_images.push({ key: "participant-image", text: this.$t("enrolments.image_participant") })
            if (this.enrolment.image) this.d_images.push({ key: "enrolment-image", text: this.$t("enrolments.image_enrolment") })

            this.output = {
              first_name: this.enrolment.first_name || this.participant.first_name,
              last_name: this.enrolment.last_name || this.participant.last_name,
              email: this.enrolment.email || this.participant.email,
              mobile: this.enrolment.mobile || this.participant.mobile,
              date_of_birth: this.enrolment.date_of_birth || this.participant.date_of_birth,
              street: this.enrolment.street || this.participant.street,
              city: this.enrolment.city || this.participant.city,
              //state: data.state,
              zip: this.enrolment.zip || this.participant.zip,
              //country: data.country,
              //company: this.enrolment.enrolment_organisation_id
              //image: this.enrolment.image ? 'enrolment-image' : (this.participant.image ? 'participant-image' : '')
            }
            this.show_compare = true

            let auto_merge = true
            if (this.d_first_names.length > 0 && this.d_first_names.length != 1) auto_merge = false
            if (this.d_last_names.length > 0 && this.d_last_names.length != 1) auto_merge = false
            if (this.d_emails.length > 0 && this.d_emails.length != 1) auto_merge = false
            if (this.d_mobiles.length > 0 && this.d_mobiles.length != 1) auto_merge = false
            if (this.d_date_of_births.length > 0 && this.d_date_of_births.length != 1) auto_merge = false
            if (this.d_streets.length > 0 && this.d_streets.length != 1) auto_merge = false
            if (this.d_cities.length > 0 && this.d_cities.length != 1) auto_merge = false
            if (this.d_zips.length > 0 && this.d_zips.length != 1) auto_merge = false
            //if(this.d_companies.length > 0 && this.d_companies.length != 1) auto_merge = false

            if (auto_merge) {
              //this.merge()
            }
          }
        })
        .catch((err) => console.log(err))
    },

    merge() {
      let vm = this

      if (this.participant && this.enrolment) {
        axios
          .post(this.API_URL + "participants/merge", {
            id: this.participant.id,
            eid: this.enrolment.id,
            first_name: this.output.first_name,
            last_name: this.output.last_name,
            email: this.output.email,
            mobile: this.output.mobile,
            date_of_birth: this.output.date_of_birth,
            street: this.output.street,
            city: this.output.city,
            //state: this.output.state,
            zip: this.output.zip,
            //country: this.output.country
            //image: this.output.image,
            company_id: this.output.company
          })
          .then((res) => {
            if (res.data.status == "ok") {
              vm.$emit("callback_enrverify_postprocess")
            } else {
              vm.$awn.alert(vm.$t("enrolments.add_to_participant_error"))
            }
            this.show = false
          })
          .catch((err) => {})
      }
    },

    createasnew() {
      this.show = false
      this.$emit("callback_enrverify_postprocess")
    },

    cancel() {
      this.show = false
      this.$emit("callback_enrverify_cancel")
    },

    showForm(id, type) {
      this.currentFormId = id
      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      this.verify(this.id, "enrolment-update", true)
      this.return_modal_cancel_form()
    },
    return_modal_cancel_form() {
      this.currentForm = null
      this.currentFormId = null
      this.showDialogForm = false
      this.$emit("return_modal_cancel_form")
    }
  }
}
</script>
<style>
.merge-table table td,
.merge-table table th {
  border-color: #ccc !important;
  height: 43px !important;
  color: #555 !important;
}

.merge-table table .grey-td {
  background-color: #eee !important;
}

.merge-table table .green-td {
  background-color: #c8e6c9 !important;
}

.merge-table table .existin-td {
  background-color: #fee8eb !important;
  color: #000 !important;
}

.merge-dropdown {
  height: 33px !important;
}

.merge-dropdown .v-input__slot::before {
  border: none !important;
}

.merge-dropdown .v-input__slot::after {
  border: none !important;
}

.merge-dropdown .v-select__selection {
  font-size: 12px !important;
}
</style>
